export default __webpack_public_path__ + "static/logo-5250c8b9db513aba5dfb556365c5f1b3.png";